import request, { ResponseData, PagerData } from '@/libs/request/request'
import { Spouse } from 'src/api/spouse/Spouse'
import { User } from 'src/api/user/User'
import { GenealogyMemberQuery } from 'src/api/genealogy/GenealogyMemberQuery'
import { ParentOrChildContact } from 'src/api/parent/ParentOrChildContact'
import { GenealogyMemberBrief } from 'src/api/genealogy/GenealogyMemberBrief'
import { AddGenealogyMember } from 'src/api/add/AddGenealogyMember'

// GenealogyMember
export type GenealogyMember = {

  // 出生时间}
  birth?:string

  createBy?:number

  createByName?:string

  // 创建时间
  createTime?:string

  // 死亡时间}
  death?:string

  // 性别 1:男 2:女
  gender?:number

  // 族谱id
  genealogyId?:number

  // 第几世}
  generation?:number

  // 业务Id
  id?:number

  // 是否过世
  isDie?:number

  // 轮播图场景名称
  name?:string

  // 祭日将近
  nearMemorialDay?:number

  // 父节点id
  parentId?:number

  // 图片(上传路径)
  picture?:string

  spouse?:Array<Spouse>

  updateBy?:number

  updateByName?:string

  // 更新时间
  updateTime?:string

  // 用户
  user?:User

  // 用户id
  userId?:number

  // 标题
  version?:number

  // 手机号
  phone?:string

  // 备注
  remarks?:string

  // 第几子
  severalSons?:number

  // word
  word?:string

  // 血亲（配偶id）
  spouseId?:number

  // 这个是母亲的id，父亲的配偶id
  motherId?:number

  life?:string

  mother?:Spouse
}

export default class GenealogyMemberService {
  /**
   * 更新一个族谱成员
   * @param {GenealogyMember} item 族谱成员实体
   **/
  static updateOneGenealogyMember (item?:GenealogyMember):Promise<ResponseData<GenealogyMember>> {
    return request<ResponseData<GenealogyMember>>({
      method: 'PUT',
      data: item,
      url: '/admin/GenealogyMember/GenealogyMember'
    })
  }

  /**
   * 添加新的一世族谱成员
   * @param {AddGenealogyMember} item 族谱成员实体
   **/
  static addOneGenealogyMemberOfNew (item?:AddGenealogyMember):Promise<ResponseData<GenealogyMember>> {
    return request<ResponseData<GenealogyMember>>({
      method: 'POST',
      data: item,
      url: '/admin/GenealogyMember/GenealogyMember/addNewGenealogyNote'
    })
  }

  /**
   * 添加同世族谱成员
   * @param {AddGenealogyMember} item 族谱成员实体（parentId=同世的一个族谱成员的parentId）
   **/
  static addOneGenealogyMemberOfSame (item?:AddGenealogyMember):Promise<ResponseData<GenealogyMember>> {
    return request<ResponseData<GenealogyMember>>({
      method: 'POST',
      data: item,
      url: '/admin/GenealogyMember/GenealogyMember/addSameGenealogyNote'
    })
  }

  /**
   * 获取族谱节点（族谱成员）的分页数据
   * @param {GenealogyMemberQuery} query 族谱成员实体查询条件
   **/
  static getPagesOfGenealogyMember (query?:GenealogyMemberQuery):Promise<ResponseData<PagerData<GenealogyMember>>> {
    return request<ResponseData<PagerData<GenealogyMember>>>({
      method: 'POST',
      data: query,
      url: '/admin/GenealogyMember/GenealogyMember/pages'
    })
  }

  /**
   * 通过id获取一个族谱成员
   * @param {number} id 族谱成员id
   **/
  static getOneGenealogyMember (id:number):Promise<ResponseData<GenealogyMemberBrief>> {
    return request<ResponseData<GenealogyMemberBrief>>({
      method: 'GET',
      url: `/admin/GenealogyMember/GenealogyMember/${id}`
    })
  }

  /**
   * 删除一个族谱节点
   * @param {number} id 族谱成员id
   **/
  static deleteOneGenealogyMember (id:number):Promise<ResponseData<boolean>> {
    return request<ResponseData<boolean>>({
      method: 'DELETE',
      url: `/admin/GenealogyMember/GenealogyMember/${id}`
    })
  }

  /**
   * 父代或者子代关联
   * @param {ParentOrChildContact} query 父代或者子代查询实体
   **/
  static parentOrChildContact (query?:ParentOrChildContact):Promise<ResponseData<PagerData<GenealogyMember>>> {
    return request<ResponseData<PagerData<GenealogyMember>>>({
      method: 'POST',
      data: query,
      url: '/admin/GenealogyMember/GenealogyMember/parentOrChildContact'
    })
  }

  /**
   * 查询族谱成员的子代
   * @param {number} id 族谱成员id
   **/
  static allNextMember (id:number):Promise<ResponseData<Array<GenealogyMember>>> {
    return request<ResponseData<Array<GenealogyMember>>>({
      method: 'POST',
      url: `/admin/GenealogyMember/GenealogyMember/${id}/children`
    })
  }

  /**
   * 获取族谱节点（族谱成员）的分页数据
   * @param {GenealogyMemberQuery} query 族谱成员实体查询条件
   **/
  static getPagesOfGenealogyMemberNoParent (query?:GenealogyMemberQuery):Promise<ResponseData<PagerData<GenealogyMember>>> {
    return request<ResponseData<PagerData<GenealogyMember>>>({
      method: 'POST',
      data: query,
      url: '/admin/GenealogyMember/GenealogyMember/notParent/pages'
    })
  }
}
